import React from 'react'
import styled from 'styled-components'
import { styleTheme } from '../../style/theme'

import { useConfig } from '../../routes'
import { Form } from './components/Form'
import { NewContactPageContainerProps, NewContactPageProps } from './NewContactPage.types'
import { RequiredIcon } from 'customer/icons/requiredMark'

export const NewContactPage: React.FC<NewContactPageContainerProps> = (props) => {
  return <StyledPage {...props} />
}

type ConfigType = {
  viewTitle: string
  topMessage: string | null
  itemRequirement: {
    address: string
    content: string
    item: boolean
    gender: string
    kana: string
    phoneNumber: string
  }
  primaryColor: string
  tenant?: {
    privacyPolicyLink?: string
  }
}

const Page: React.FC<NewContactPageProps> = ({ className }) => {
  const config = useConfig() as ConfigType

  return (
    <div className={className}>
      {config.viewTitle && <h3 className="title">{config.viewTitle}</h3>}
      {config.topMessage && <pre className="top-message">{config.topMessage}</pre>}
      <p className="description">
        <RequiredIcon />
        <span className="text">入力必須項目です</span>
      </p>
      <Form
        formItemRequirement={config.itemRequirement}
        primaryColor={config.primaryColor}
        privacyPolicyLink={config.tenant?.privacyPolicyLink}
      />
    </div>
  )
}

const StyledPage = styled(Page)`
  max-width: 768px;
  margin: 0 auto;
  background-color: ${styleTheme.colors.white};
  padding: 32px 16px;

  > .title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  > .top-message {
    font-size: 14px;
    color: ${styleTheme.colors.black};
    line-height: 1.8;
  }

  > .description {
    display: flex;
    gap: 4px;
    font-size: 14px;
    color: ${styleTheme.colors.black};
    line-height: 1.5;
    margin-bottom: 24px;

    > .text {
      color: #ff5757;
    }
  }
`
